import { SubscriptionCheckout } from '../../ui';

const SubscribeContainer = () => {
  return <SubscriptionCheckout returnUrl={`${window.location.origin}/edit/check-subscription`} />;
};

export default SubscribeContainer;
